// extracted by mini-css-extract-plugin
export default {"content":"BuildPanel_content__iTSer","panel":"BuildPanel_panel__NVM6x"};